<template>
  <div class="layer-content" @click="onClick">
    <div class="titel">
      <span>{{stijl.titel}}</span>
    </div>
    <div class="image">
      <img :src="stijl.img">
    </div>
  </div>
</template>
<style scoped>
.layer-content {
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  cursor: pointer;
  /* width: auto; */
  overflow: hidden;
  margin: 2px 0px 2px 0px;
}
.image {
  background-color: rgba(240, 238, 234, 1);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  width: 40px;
  height: 40px;
}
.image img {
  padding: 0px;
  width: 40px;
  height: 40px;
}
.titel {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);

  white-space: nowrap;
  height: 40px;
  background: rgba(240, 238, 234, 0.8);
  padding: 15px;
  width: auto;
}
.titel span {
  padding: 0px;
  margin: 0px;
  font-family: RijksoverheidSansText;
  font-size: 12px;
  line-height: 13px;
  color: #55574a;
}
</style>
<script>
export default {
  name: "MapLayer",
  props: ["stijl"],
  data() {
    return {};
  },
  methods: {
    onClick() {
      this.$store.commit('map/setStyle',this.stijl.url)
    }
  }
};
</script>
